<template>
  <BaseModal
    ref="baseModalRef"
    :title="'Videos'"
    modal-id="videos"
    :isVisible="true"
    @close="closeDialog"
    @minimize="$emit('minimize', 'videos')"
    @restore="$emit('restore', 'videos')"
  >
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="row h-100">
          <div class="h-70 media-container media-container-small">
            <video-player
              ref="videoPlayerRef"
              v-if="reRenderPlayer"
              class="video-player vjs-theme-forest"
              :options="videoOptions"
              @timeChange="timeChange"
            />
          </div>
          <div class="row h-30">
            <div class="col-2 col-2-small filters-small">
               <div><button  class="btn btn-secondary btn-sm btn-vlc-selected"
                @click="abrirEnVLC"
                >Abrir en VLC</button></div>
              <h5>Filtros</h5>
              <div class="row">
                <div class="filters-col-small">
                  <select
                    class="form-select form-select-sm mb-1"
                    v-model="filters.data"
                    aria-label=""
                    @change="callApi"
                  >
                    <option selected value="">Video</option>
                    <option value="PRIMARY">Primary</option>
                    <option value="ALTERNATE">Alternate</option>
                  </select>

                  <div class="filter-group">
                    <!-- FECHA DESDE -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showStartDate"
                        v-model="filters.showStartDate"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Desde </label>
                    </div>
                    <div v-if="filters.showStartDate">
                      <input
                        type="date"
                        v-model="filters.start_date"
                        @change="callApi"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- FECHA HASTA -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showEndDate"
                        v-model="filters.showEndDate"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
                    </div>
                    <div v-if="filters.showEndDate">
                      <input
                        type="date"
                        v-model="filters.end_date"
                        @change="callApi"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- TIPO -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="type"
                        v-model="filters.showTipo"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Tipo </label>
                    </div>
                    <div :hidden="!filters.showTipo">
                      <select v-model="filters.tipo" @change="callApi" class="form-control">
                        <option class="form-select form-select-sm" value="HD-EO">HD-EO</option>
                        <option class="form-select form-select-sm" value="MWIR">MWIR</option>
                      </select>
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- ZONA -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showZona"
                        v-model="filters.showZona"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Zona </label>
                    </div>
                    <div :hidden="!filters.showZona" class="form-text">
                      <label class="form-text-label" for="flexTextDefault"> Lat </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="init_number"
                        v-model="filters.lat_zona"
                        @change="callApi"
                      />
                      <label class="form-text-label" for="flexTextDefault"> Lon </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="end_number"
                        v-model="filters.lon_zona"
                        @change="callApi"
                      />

                      <label class="form-text-label" for="flexTextDefault"> Radio </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="end_number"
                        v-model="filters.rad_zona"
                        @change="callApi"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- PREDIO -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showPredios"
                        v-model="filters.showPredio"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Predio </label>
                    </div>
                    <div :hidden="!filters.showPredio" v-if="prediosList">
                      <select
                        class="form-select form-select-sm"
                        aria-label="Default select example"
                        v-model="filters.predio_name"
                        @change="callApi"
                      >
                        <option v-for="predio in prediosList" v-bind:key="predio.name">
                          {{ predio.name }}
                        </option>
                      </select>
                      <label class="form-text-label" for="flexTextDefault"> Radio </label>
                      <input
                        class="form-number-input"
                        type="number"
                        v-model="filters.predio_rad"
                        @change="callApi"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-5 col-5-small">
              <div class="text-center">
                <label
                  >Videos Filtrados <span>({{ cantidadVideos }})</span></label
                >
              </div>
              <div class="video-list">
                <div
                  v-for="video in videoFiles"
                  :key="video.id_file"
                  @click="changeVideo(video.file_name, video.id_file)"
                  class="video-list-item"
                  :class="{ selected: currentVideoId === video.id_file }"
                >
                  {{ video.file_name.split('\\')[1] }}
                </div>
              </div>
            </div>
           
            <div class="datos-media datos-media-small" :key="currentVideoDetail?.utc">
              
              <div class="row">
                <div class="col-3">
                  <label>Archivo</label>
                </div>
                <div class="col-9">
                  <label>{{ video.fileName.split('\\').pop() }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>UTC</label>
                </div>
                <div class="col-9">
                  <label>{{ formatUtc(currentVideoDetail?.utc) }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Tipo</label>
                </div>
                <div class="col-9">
                  <label>{{ currentVideoDetail?.name }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Avión</label>
                </div>
                <div class="col-9">
                  <label
                    >{{ currentVideoDetail?.sensor_lat }} {{ currentVideoDetail?.sensor_lon }} Rumbo
                    {{ currentVideoDetail?.platform_heading }}°
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>FOV</label>
                </div>
                <div class="col-9">
                  <label
                    >H: {{ currentVideoDetail?.sensor_hfov }}° V:{{
                      currentVideoDetail?.sensor_vfov
                    }}°</label
                  >
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Distancia Blanco</label>
                </div>
                <div class="col-9">
                  <label>{{ currentVideoDetail?.slant_range }} M</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Centro Imagen</label>
                </div>
                <div class="col-9">
                  <label
                    >{{ currentVideoDetail?.center_lat }}
                    {{ currentVideoDetail?.center_lon }}</label
                  >
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Tamaño Objetivo</label>
                </div>
                <div class="col-9">
                  <label>{{ currentVideoDetail?.targetwidth }} M</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { ref, reactive, onMounted, watch } from 'vue'
import BaseModal from './base/BaseModal.vue'
import VideoPlayer from './VideoPlayer.vue'
import 'video.js/dist/video-js.css'
import { useBrowserDetect } from 'vue3-detect-browser'
import type { VideoFile, VideoFilesFilter, VideoDetail } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import { useGlobalStore } from '@/stores/global'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

const global = useGlobalStore()
const { currentVideoId, currentVideoDetail, videoDetails, selectedVideoMarker } =
  storeToRefs(global)

const serv = useServicesStore()
const { prediosList } = storeToRefs(serv)

const { isSafari } = useBrowserDetect()

const videoFiles = ref<VideoFile[]>([])
const cantidadVideos = ref(0)
const videoPlayerRef = ref()
const currentVideoName = ref('')



const filters = reactive({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: '',
  data: '',
  showTipo: false,
  tipo: '',
  inicio_objetivo: 0,
  final_objetivo: 0,
  showZona: false,
  lat_zona: 0,
  lon_zona: 0,
  rad_zona: 10,
  showPredio: false,
  predio_name: '',
  predio_rad: 10
})
const video = reactive({
  fileName: ''
})

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'videoSelected', coordenadas: number[]): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
}>()

function playFromFrametime(frametimeMs: number) {
  // Espera un poco si es necesario para que el video esté listo
  setTimeout(() => {
    videoPlayerRef.value?.seekTo(frametimeMs)
  }, 300)
}

function closeDialog() {
  emit('closed')
}

// console.log('isSafari:' + isSafari)
// console.log('isChrome:' + isChrome)
const videoOptions = reactive({
  //techOrder: ["html5", "other supported tech"],
  autoplay: true,
  controls: true,
  fluid: true,
  preload: 'auto',
  html5: {
    vhs: {
      overrideNative: !isSafari,
      bandwidth: 5039
    },
    nativeAudioTracks: false,
    nativeVideoTracks: false
  },
  sources: [
    {
      src: '/videos/2024-02-28_19-21-13/2024-02-28_19-21-13_PRIMARY.m3u8',
      type: 'application/x-mpegURL'
      //type: 'video/mp4',
    }
  ],
  // src: '/videos/2024-02-28_19-21-13/2024-02-28_19-21-13_PRIMARY.ts',
  // type: 'application/x-mpegURL',
  width: 500,
  height: 300
})
const baseModalRef = ref()

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  }
})
function formatUtc(str?: string): string {
  if (!str) return ''
  // Espera formato: "2024-02-28_18-41-37-003"
  const match = str.match(/^(\d{4}-\d{2}-\d{2})_(\d{2})-(\d{2})-(\d{2})-(\d{3})$/)
  if (!match) return str
  const [, date, hh, mm, ss, ms] = match
  return `${date} ${hh}:${mm}:${ss}.${ms}`
}
onMounted(() => {
  callApi()
})
const reRenderPlayer = ref(false)

function changeVideo(file_name: string, id_file: number) {
  currentVideoId.value = id_file
  video.fileName = file_name
  currentVideoName.value  = file_name
  reRenderPlayer.value = false
  videoOptions.sources[0].src = '/fserver/videos/' + file_name + '.m3u8'
  listVideoDetails(id_file)

  setTimeout(() => {
    reRenderPlayer.value = true
    emit('videoSelected', [
      parseFloat(currentVideoDetail.value?.center_lon || '0'),
      parseFloat(currentVideoDetail.value?.center_lat || '0')
    ])
    if (selectedVideoMarker.value !== undefined && selectedVideoMarker.value !== null) {
      playFromFrametime(selectedVideoMarker.value)
    }
    selectedVideoMarker.value = null
  }, 100)
}
async function listVideoDetails(id_file: number) {
  try {
    const { status, data } = await API.listVideoDetails(id_file)

    if (status == 200) {
      console.log(data)
      const entries = data.Entries?.Entry
      videoDetails.value = Array.isArray(entries) ? entries : entries ? [entries] : []
      currentVideoDetail.value = videoDetails.value[0]
    } else {
      console.log('error')
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
  }
}
function timeChange(currentTime: number) {
  // console.log('time changed:' + currentTime)
  const closestDetail = videoDetails.value.reduce((prev, curr) => {
    return Math.abs(parseFloat(curr.frametime) - currentTime) <
      Math.abs(parseFloat(prev.frametime) - currentTime)
      ? curr
      : prev
  })

  currentVideoDetail.value = { ...closestDetail }
}
async function abrirEnVLC() {
  // Usa el archivo actual mostrado en el reproductor
  const url = 'https://apialerce.terminus.cl/fserver/videos/' + currentVideoName.value.replace('\\', '/') + '.ts';
  console.log('Llamando a VLC con URL: ' + url);
  const start_time = currentVideoDetail.value && currentVideoDetail.value.frametime
    ? parseFloat(currentVideoDetail.value.frametime)
    : 0;
  const payload = {
    url, 
    fullscreen: false,
    volume: 100,
    start_time: start_time
  };
  try {
    await fetch('http://localhost:8001/play', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (e) {
    alert('No se pudo comunicar con la API local de VLC.');
  }
}
async function callApi() {
  const filtros: VideoFilesFilter = {
    start_date: filters.showStartDate ? filters.start_date.replace(/-/g, '') : '',
    end_date: filters.showEndDate ? filters.end_date.replace(/-/g, '') : '',
    data: filters.data,
    tipo: filters.showTipo ? filters.tipo : '',
    inicio_objetivo: 0,
    final_objetivo: 0,
    lat_zona: filters.showZona ? filters.lat_zona : 0,
    lon_zona: filters.showZona ? filters.lon_zona : 0,
    rad_zona: filters.showZona ? filters.rad_zona : 0,
    predio_name: filters.showPredio ? filters.predio_name : '',
    predio_rad: filters.showPredio ? filters.predio_rad : 0
  }
  try {
    const { status, data } = await API.getVideos(filtros)

    if (status == 200) {
      videoFiles.value = data.Entries?.Entry || []
      cantidadVideos.value = videoFiles.value.length
    } else {
      videoFiles.value = []
      cantidadVideos.value = 0
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    videoFiles.value = []
    cantidadVideos.value = 0
  }
}
watch(selectedVideoMarker, (newVal) => {
  if (currentVideoId.value !== null && currentVideoId.value !== undefined) {
    changeVideo(video.fileName, currentVideoId.value)
  }
})
</script>
<style lang="css" scoped>
/* clase global para los close de los modales */
.form {
  background-color: transparent;
}

span.closeCampos.close {
  height: 25px;
  line-height: 9px;
  background-color: #6c757d;
  padding: 6px;
  border-radius: 5px;
}

/* alto de tabla contenedor */

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.my-3 {
  min-height: 1px;
}

.modal-container {
  min-width: 536px;
  width: 470px;
  height: 530px;
  min-height: 385px;
  max-height: 85vh;
}

.video-list-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.video-list-item.selected {
  background: #ffe082;
  color: black;
  font-weight: bold;
}

.video-list-item:hover {
  background: #f5f5f5;
}

@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }
}
.btn-vlc-selected {
  font-size: 11px !important;
}
</style>
